import { TextField } from '@tmov/design-system';
import { WaveVariantB } from '@tmov/design-system/icons';
import { notification } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { LoadingContainer } from '../../../../components/LoadingContainer';
import {
  limitarLabel,
  removeCaracteresEspeciais,
  toTitleCase,
} from '../../../../helpers/formatador';
import apiShipper from '../../../../services/apiShipper';
import {
  ButtonCancel,
  ButtonPrimary,
  CustomModal,
  ModalContent,
  ModalInfo,
  ModalTitle,
} from './styles';

const ModalVencedor = ({
  modalVisible,
  handleClose,
  propostaData,
  idCotacao,
}) => {
  const [localValue, setLocalValue] = useState('');
  const [idVencedores, setIdVencedores] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const refreshPage = async () => {
    setConfirmLoading(true);
    window.location.reload(false);
    setConfirmLoading(false);
  };

  const localFormat = value => {
    if (!value) return '';
    if (value.length <= 2) return value;
    let inicio;
    let meio;
    let final;
    if (value.length <= 5) {
      inicio = value.slice(0, value.length - 2);
      final = value.slice(value.length - 2, value.length);
      return `${inicio},${final}`;
    }
    if (value.length <= 7) {
      inicio = value.slice(0, value.length - 5);
      meio = value.slice(value.length - 4, value.length - 1);
      final = value.slice(value.length - 2, value.length);
      return `${inicio}.${meio},${final}`;
    }
    return value;
  };

  const handleValorFinal = event => {
    const { value } = event.target;
    if (value.length > 7) return;
    const valueSemVirgula = removeCaracteresEspeciais(value);
    const somenteNumeros = valueSemVirgula.replace(/\D/g, '');
    const variavel = localFormat(somenteNumeros);
    setLocalValue(variavel);
  };

  const handleCancelar = () => {
    setLocalValue(null);
    handleClose();
  };

  const handleConcluir = async () => {
    try {
      setConfirmLoading(true);

      propostaData.forEach(item => {
        if (item.aprovada === true) {
          idVencedores.push(item.id);
        }
      });
      setIdVencedores(idVencedores);

      await apiShipper.put('cotacoes/propostas/aprovar', {
        ids: idVencedores,
        valorFinal: localValue.replace(',', '.'),
        idCotacao,
      });
    } catch (error) {
      notification.error({
        message: 'Falha ao selecionar vencedores.',
      });
    } finally {
      handleCancelar();
      setConfirmLoading(false);
      await refreshPage();
    }
  };

  const handleValidaButton = () => {
    if (!localValue) {
      return true;
    }

    return false;
  };

  return (
    <>
      <CustomModal
        closable={false}
        visible={modalVisible}
        destroyOnClose={true}
        footer={[
          <ButtonCancel key="cancelar" onClick={() => handleCancelar()}>
            Cancelar
          </ButtonCancel>,

          <ButtonPrimary
            key="concluir"
            onClick={() => handleConcluir()}
            disabled={handleValidaButton() || confirmLoading}
          >
            Concluir
          </ButtonPrimary>,
        ]}
      >
        <ModalTitle>Confirmar vencedor</ModalTitle>
        <ModalInfo regular>Transportadora</ModalInfo>
        {propostaData.map(
          proposta =>
            proposta.aprovada === true && (
              <ModalInfo key={proposta.id}>
                {`${limitarLabel(toTitleCase(proposta.razao_social), 30)}`}
              </ModalInfo>
            )
        )}
        <ModalContent>
          <TextField
            value={localValue}
            label="Valor Final"
            required={true}
            size="sm"
            onChange={event => handleValorFinal(event)}
            style={{ width: '184px' }}
          />
        </ModalContent>

        {confirmLoading && (
          <LoadingContainer height="10vh">
            <WaveVariantB size="30px" />
          </LoadingContainer>
        )}
      </CustomModal>
    </>
  );
};

ModalVencedor.propTypes = {
  modalVisible: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  propostaData: PropTypes.arrayOf(PropTypes.object).isRequired,
  idCotacao: PropTypes.string.isRequired,
};

ModalVencedor.defaultProps = {
  modalVisible: false,
};

export default ModalVencedor;
